module.exports = __webpack_public_path__ + "static/img/certificate.6731da36.png";